<template>
  <div style="position: relative">
    <FilterFields
      :fields="[
        {
          type: 'text',
          label: 'Nome',
          field: 'nome',
        },
        {
          type: 'text',
          label: 'E-mail',
          field: 'email',
        },
        {
          type: 'text',
          label: 'CPF/CNPJ',
          field: 'cnpj_cpf',
        },
        {
          type: 'date',
          label: 'Data Cadastro',
          field: 'created_at',
        },
        {
          type: 'date',
          label: 'Data Vencimento',
          field: 'data_validade',
        },
        {
          type: 'select',
          label: 'Tipo',
          field: 'tipo',
          options: ['Cliente', 'Revenda', 'Todos'],
        },
        {
          type: 'select',
          label: 'Plano',
          field: 'plano',
          options: [
            'Free',
            'Essencial Anual',
            'Essencial Mensal',
            'Standard Mensal',
            'Standard Anual',
            'Todos',
          ],
        },
      ]"
    />

    <b-dropdown
      id="menu"
      variant="dark"
      v-b-tooltip.right="'Mais ações'"
      style="position: absolute; top: 0; left: 50px"
      v-if="currentUser.admin"
    >
      <template #button-content>
        <Menu :size="18" />
      </template>
      <b-dropdown-item v-b-modal.clientesNuts
        >Relatório Clientes Nuts
      </b-dropdown-item>
      <b-dropdown-item v-b-modal.clientesRevendas
        >Relatório Clientes Revendas
      </b-dropdown-item>
      <b-dropdown-item v-b-modal.clientePorUF
        >Relatório Clientes por UF/Cidade
      </b-dropdown-item>
      <b-dropdown-item v-b-modal.clientesMensal
        >Relatório Clientes Mensal
      </b-dropdown-item>
      <b-dropdown-item v-b-modal.faturamentoSegmentado
        >Faturamento por tipo
      </b-dropdown-item>
    </b-dropdown>

    <b-modal
      id="faturamentoSegmentado"
      title="Informe o período para o relatório de faturamento"
      centered
      size="sm"
    >
      <b-form-group label="Data Início">
        <b-form-input v-model="formFaturamento.data_inicio" type="date" />
      </b-form-group>

      <b-form-group label="Data Fim">
        <b-form-input v-model="formFaturamento.data_fim" type="date" />
      </b-form-group>

      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarFaturamentoSegmentado"
            ref="faturamentoSegmentado"
            class="mr-5"
          >
            Gerar Relatório
          </b-button>
          <b-button @click="cancel"> Cancelar </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="clientesMensal"
      title="Esse relatório será somente dos clientes Nuts Mensal!"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarRelatorioMensal"
            ref="clientesMensal"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="clientesNuts"
      title="Esse relatório será somente dos clientes Nuts!"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarRelatorioNuts"
            ref="clientesNuts"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="clientePorUF"
      title="Esse relatório será somente dos clientes Nuts!"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarRelatorioPorUF"
            ref="clientePorUF"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="clientesRevendas"
      title="Esse relatório será somente dos clientes das Revendas Nuts!"
      centered
      size="xs"
    >
      <template #modal-footer="{ ok, cancel }">
        <div>
          <b-button
            variant="primary"
            @click="gerarRelatorioRevendasNuts"
            ref="clientesRevendas"
            class="mr-5"
          >
            Confirmar
          </b-button>
          <b-button
            @click="
              {
                cancel();
              }
            "
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>

    <TableApp
      titulo="Revendas/Clientes"
      subTitulo="Nuts"
      api-url="empresa/clientes"
      :fields="fields"
      classFilterColumn="clientes"
      ref="clientes"
      :perPage="10"
      @loaded="atualizarResumoPainel"
    >
      <template slot="customRow" slot-scope="props">
        <span slot="nome" v-if="props.field == 'nome'">
          <span class="cliente-cell">
            <span class="cliente-main">{{ props.rowData.nome }}</span>
            <span class="cliente-muted">
              Revenda: {{ props.rowData.revenda_nome || "Não informada" }}
            </span>
            <span class="cliente-muted" v-if="props.rowData.fone">
              Telefone: {{ props.rowData.fone }}
            </span>
            <span class="cliente-muted">
              {{ cidadeUfCliente(props.rowData) }}
            </span>
            <span class="cliente-chip-wrap" v-if="props.rowData.revenda">
              <span class="label label-sm label-inline label-light-success">
                Revenda
              </span>
            </span>
            <span class="d-none">{{ registrarResumoLinha(props.rowData) }}</span>
          </span>
        </span>

        <span slot="cnpj_cpf" v-if="props.field == 'cnpj_cpf'">
          <span class="documento-cell">
            <div class="font-weight-bolder font-size-lg mb-0" v-if="props.rowData.cnpj_cpf">
              {{ formatCpfCnpj(props.rowData.cnpj_cpf) }}
            </div>
            <div class="font-weight-bold text-muted" v-show="props.rowData.ie_rg">
              IE: {{ props.rowData.ie_rg }}
            </div>
          </span>
        </span>

        <span slot="data_validade" v-if="props.field == 'data_validade'">
          <div class="license-summary-cell licenca-cell">
            <div class="license-plan-line">
              <span class="license-plan-badge">
                {{ siglaPlanoLicenca(props.rowData) }}
              </span>
              <strong>{{ nomePlanoLicenca(props.rowData) }}</strong>
            </div>
            <div class="license-muted" v-if="dataValidadeLicenca(props.rowData)">
              Vence: {{ dataValidadeLicenca(props.rowData) }}
            </div>

            <div class="license-lines">
              <div class="license-row">
                <span>Plano</span>
                <strong>
                  {{ formatarMoedaLicenca(valorAnualPlanoLicenca(props.rowData)) }}/ano
                </strong>
              </div>

              <template v-if="totalAppsAtivosLicenca(props.rowData) > 0">
                <div
                  class="license-row license-muted"
                  v-if="totalAnualAppsLicenca(props.rowData) > 0"
                >
                  <span>Anual apps</span>
                  <span>
                    {{ formatarMoedaLicenca(totalAnualAppsLicenca(props.rowData)) }}/ano
                  </span>
                </div>
              </template>
            </div>
          </div>
        </span>

        <span slot="apps" v-if="props.field == 'apps'">
          <div class="apps-cell">
            <template v-if="totalAppsAtivosLicenca(props.rowData) > 0">
              <div class="apps-active-count">
                {{ totalAppsAtivosLicenca(props.rowData) }} apps ativos
              </div>
              <div class="apps-active-names">
                {{ resumoAppsLicenca(props.rowData) }}
              </div>
              <b-button
                size="sm"
                variant="light-primary"
                class="mt-2"
                @click="abrirModalAppsLicenca(props.rowData)"
              >
                Ver apps
              </b-button>
            </template>
          </div>
        </span>

        <span slot="revenda_info" v-if="props.field == 'revenda_info'">
          <div class="reseller-info-cell" v-if="props.rowData.revenda">
            <div class="reseller-info-line">
              <span>Nível Partner</span>
              <strong>{{ nivelPartnerRevenda(props.rowData) }}</strong>
            </div>
            <div class="reseller-info-line">
              <span>Licenças Nuts</span>
              <strong>{{ totalLicencasRevenda(props.rowData) }}</strong>
            </div>
          </div>
          <span v-else class="license-empty">Cliente</span>
        </span>

        <span slot="status" v-if="props.field == 'status'">
          <div class="status-cell">
            <span
              class="label label-sm label-inline"
              :class="clienteBloqueado(props.rowData) ? 'label-light-danger' : 'label-light-success'"
            >
              {{ clienteBloqueado(props.rowData) ? "Bloqueado" : "Ativo" }}
            </span>
          </div>
        </span>

        <span slot="actions" v-if="props.field == 'actions'">
          <div class="row-actions">
            <b-button
              :id="`revenda-acoes-${props.rowData.id_empresa}`"
              size="sm"
              variant="light-primary"
              class="row-actions-toggle"
              aria-label="Abrir ações do cliente"
            >
              <Menu :size="16" class="mr-1" />
              Ações
            </b-button>

            <b-popover
              :target="`revenda-acoes-${props.rowData.id_empresa}`"
              triggers="click blur"
              placement="bottom-end"
              boundary="viewport"
              container="body"
              custom-class="revenda-actions-popover"
            >
              <div class="revenda-actions-menu">
              <button
                type="button"
                class="dropdown-item"
                @click="
                  $router.push({
                    name: 'revendasEditar',
                    params: { id_empresa: props.rowData.id_empresa },
                  })
                "
              >
                <Eye :size="16" class="action-item-icon" />
                Visualizar cliente
              </button>

              <button
                v-if="currentUser.admin && isNuts"
                type="button"
                class="dropdown-item"
                @click="abrirModalFeatures(props.rowData)"
              >
                <AppsIcon :size="16" class="action-item-icon" />
                Gerenciar módulos e plugins
              </button>

              <button
                v-if="isNuts"
                type="button"
                class="dropdown-item"
                @click="abrirModalUsuarios(props.rowData)"
              >
                <AccountGroup :size="16" class="action-item-icon" />
                Usuários e senhas
              </button>

              <button
                type="button"
                class="dropdown-item"
                @click="abrirModalPlano(props.rowData)"
              >
                <CreditCard :size="16" class="action-item-icon" />
                Alterar plano
              </button>

              <div class="dropdown-divider" />

              <button
                v-if="clienteBloqueado(props.rowData)"
                type="button"
                class="dropdown-item"
                @click="liberarAcesso(props.rowData)"
              >
                <LockOpen :size="16" class="action-item-icon text-success" />
                Liberar acesso
              </button>
              <button
                v-else
                type="button"
                class="dropdown-item"
                @click="bloquearAcesso(props.rowData)"
              >
                <Lock :size="16" class="action-item-icon text-danger" />
                Bloquear acesso
              </button>

              <button
                v-if="!props.rowData.revenda"
                type="button"
                class="dropdown-item"
                @click="tornarRevenda(props.rowData)"
              >
                <OfficeBuilding :size="16" class="action-item-icon" />
                Tornar revenda
              </button>

              <button
                type="button"
                class="dropdown-item"
                @click="verUsoEmpresa(props.rowData)"
              >
                <Analytics :size="16" class="action-item-icon" />
                Análise de uso
              </button>

              <button
                type="button"
                class="dropdown-item"
                @click="setarCreditosUnicheck(props.rowData)"
              >
                <Cash :size="16" class="action-item-icon" />
                Informar créditos Unicheck
              </button>

              <template v-if="props.rowData.revenda">
                <div class="dropdown-divider" />

                <button
                  type="button"
                  class="dropdown-item"
                  @click="
                    $router.push({
                      name: 'revendasListaClientes',
                      params: {
                        id_revenda: props.rowData.id_empresa,
                        rota: 'revendasLista',
                      },
                    })
                  "
                >
                  <AccountGroup :size="16" class="action-item-icon" />
                  Lista de clientes
                </button>
                <button
                  v-if="isNuts"
                  type="button"
                  class="dropdown-item"
                  @click="abrirModalSaldoApps(props.rowData)"
                >
                  <Briefcase :size="16" class="action-item-icon" />
                  Saldo de Apps da revenda
                </button>
                <button
                  type="button"
                  class="dropdown-item"
                  @click="setarLicencas(props.rowData)"
                >
                  <License :size="16" class="action-item-icon" />
                  Informar licenças para revenda
                </button>
                <button
                  type="button"
                  class="dropdown-item"
                  @click="setarNivel(props.rowData)"
                >
                  <Medal :size="16" class="action-item-icon" />
                  Nível Partner
                </button>
                <button
                  v-if="currentUser.admin && nivelPartnerRevendaNumero(props.rowData) === 5"
                  type="button"
                  class="dropdown-item"
                  @click="abrirModalUploadPdvOffline(props.rowData)"
                >
                  <CloudUpload :size="16" class="action-item-icon" />
                  Upload PDV Offline
                </button>
              </template>
              </div>
            </b-popover>
          </div>
        </span>
      </template>
    </TableApp>

    <b-modal
      id="modal-usuarios-empresa"
      :title="
        empresaUsuariosSelecionada
          ? 'Usuários — ' + empresaUsuariosSelecionada.nome
          : 'Usuários da empresa'
      "
      hide-footer
      centered
      size="lg"
    >
      <div v-if="loadingUsuarios" class="text-center py-5">
        <b-spinner variant="primary" label="Carregando..." />
        <p class="mt-3 text-muted">Carregando usuários da empresa...</p>
      </div>

      <b-alert v-else-if="erroUsuarios" show variant="danger" class="mb-0">
        {{ erroUsuarios }}
      </b-alert>

      <div v-else-if="!usuariosEmpresa.length" class="empty-users-state">
        Nenhum usuário encontrado para esta empresa.
      </div>

      <div v-else class="company-users-list">
        <div
          v-for="usuario in usuariosEmpresa"
          :key="usuario.id_usuario"
          class="company-user-item"
        >
          <div class="company-user-info">
            <div class="d-flex align-items-center flex-wrap">
              <strong>{{ usuario.nome || "Sem nome informado" }}</strong>
              <span
                class="label label-sm label-inline ml-2"
                :class="usuario.status === 'A' ? 'label-light-success' : 'label-light-danger'"
              >
                {{ usuario.status === "A" ? "Ativo" : "Inativo" }}
              </span>
              <span
                v-if="usuario.admin"
                class="label label-sm label-inline label-light-primary ml-2"
              >
                Administrador
              </span>
            </div>
            <span class="text-muted">{{ usuario.usuario }}</span>
          </div>

          <b-button
            size="sm"
            variant="outline-primary"
            @click="abrirAlteracaoSenha(usuario)"
          >
            Alterar senha
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-alterar-senha-usuario"
      title="Alterar senha do usuário"
      hide-footer
      centered
      size="sm"
    >
      <div v-if="usuarioSenhaSelecionado">
        <p class="mb-4">
          Usuário: <strong>{{ usuarioSenhaSelecionado.nome || usuarioSenhaSelecionado.usuario }}</strong>
        </p>

        <b-form-group label="Nova senha" label-for="nova-senha-usuario">
          <b-form-input
            id="nova-senha-usuario"
            v-model="formSenha.password"
            type="password"
            autocomplete="new-password"
            minlength="4"
            maxlength="72"
            placeholder="Mínimo de 4 caracteres"
          />
        </b-form-group>

        <b-form-group label="Confirmar nova senha" label-for="confirmar-senha-usuario">
          <b-form-input
            id="confirmar-senha-usuario"
            v-model="formSenha.password_confirmation"
            type="password"
            autocomplete="new-password"
            minlength="4"
            maxlength="72"
          />
        </b-form-group>

        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            :disabled="salvandoSenha"
            @click="$bvModal.hide('modal-alterar-senha-usuario')"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            :disabled="salvandoSenha"
            @click="salvarSenhaUsuario"
          >
            <b-spinner small class="mr-2" v-if="salvandoSenha"></b-spinner>
            {{ salvandoSenha ? "Salvando..." : "Salvar nova senha" }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-alterar-plano"
      title="Alterar plano"
      hide-footer
      centered
    >
      <div v-if="clientePlanoSelecionado">
        <p class="mb-3">
          Cliente: <strong>{{ clientePlanoSelecionado.nome }}</strong>
        </p>

        <b-form-group label="Selecione o novo plano">
          <b-form-select v-model="formPlano.id_plan" :options="opcoesPlanos" />
        </b-form-group>

        <b-form-group label="Data de validade">
          <b-form-input v-model="formPlano.data_validade" type="date" />
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            :disabled="salvandoPlano"
            @click="$bvModal.hide('modal-alterar-plano')"
          >
            Cancelar
          </b-button>

          <b-button
            variant="primary"
            :disabled="salvandoPlano"
            @click="salvarPlano"
          >
            <b-spinner small class="mr-2" v-if="salvandoPlano"></b-spinner>
            {{ salvandoPlano ? "Salvando..." : "Salvar" }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-apps-licenca"
      :title="
        clienteAppsSelecionado
          ? 'Apps do cliente — ' + clienteAppsSelecionado.nome
          : 'Apps do cliente'
      "
      hide-footer
      centered
      size="lg"
    >
      <div v-if="!appsClienteSelecionado.length" class="empty-apps-state">
        Nenhum app ativo para este cliente.
      </div>
      <div v-else class="apps-detail-list">
        <div
          class="apps-detail-item"
          v-for="(app, idx) in appsClienteSelecionado"
          :key="`${idx}-${app.feature_code || app.code || app.nome || app.name}`"
        >
          <div>
            <strong>{{ nomeAppDetalheLicenca(app) }}</strong>
            <div class="apps-detail-meta">
              {{ tipoAppDetalheLicenca(app) }}
            </div>
            <div class="apps-detail-meta">
              Origem: {{ origemAppDetalheLicenca(app) }}
            </div>
          </div>
          <div class="apps-detail-price">{{ valorAppDetalheLicenca(app) }}</div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-saldo-apps-revenda"
      :title="
        revendaSaldoSelecionada
          ? 'Saldo de Apps — ' + revendaSaldoSelecionada.nome
          : 'Saldo de Apps'
      "
      hide-footer
      centered
      size="lg"
    >
      <div class="saldo-apps-modal">
        <div class="saldo-apps-header mb-3" v-if="revendaSaldoSelecionada">
          <div>
            <span class="saldo-apps-label">Revenda:</span>
            <strong>{{ revendaSaldoSelecionada.nome }}</strong>
          </div>
          <div>
            <span class="saldo-apps-label">CNPJ/CPF:</span>
            <strong>{{ documentoRevendaSaldoSelecionada }}</strong>
          </div>
        </div>

        <div class="saldo-cards-grid">
          <div class="saldo-card-item">
            <span>Saldo disponível</span>
            <strong>{{ formatarMoedaLicenca(saldoAppsRevenda.disponivel) }}</strong>
          </div>
          <div class="saldo-card-item">
            <span>Saldo usado</span>
            <strong>{{ formatarMoedaLicenca(saldoAppsRevenda.usado) }}</strong>
          </div>
          <div class="saldo-card-item">
            <span>Total creditado</span>
            <strong>{{ formatarMoedaLicenca(saldoAppsRevenda.creditado) }}</strong>
          </div>
        </div>

        <div class="saldo-credit-form mt-3">
          <h6 class="mb-2">Adicionar crédito</h6>
          <b-row>
            <b-col md="4" sm="12">
              <b-form-group label="Valor">
                <b-form-input
                  v-model="formCreditoApps.valor"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0,00"
                />
              </b-form-group>
            </b-col>
            <b-col md="8" sm="12">
              <b-form-group label="Observação">
                <b-form-input
                  v-model.trim="formCreditoApps.observacao"
                  placeholder="Motivo do crédito"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            :disabled="salvandoCreditoApps || !revendaSaldoSelecionada"
            @click="adicionarCreditoAppsRevenda"
          >
            <b-spinner small class="mr-2" v-if="salvandoCreditoApps" />
            {{ salvandoCreditoApps ? "Adicionando..." : "Adicionar crédito" }}
          </b-button>
        </div>

        <div class="saldo-extrato mt-4">
          <h6 class="mb-2">Extrato de movimentações</h6>
          <div v-if="loadingSaldoAppsRevenda" class="text-muted">
            Carregando saldo da revenda...
          </div>
          <div v-else-if="erroSaldoAppsRevenda" class="text-muted">
            {{ erroSaldoAppsRevenda }}
          </div>
          <div v-else-if="!extratoSaldoAppsRevenda.length" class="text-muted">
            Nenhuma movimentação encontrada.
          </div>
          <div v-else class="table-responsive saldo-extrato-table-wrap">
            <table class="table table-sm saldo-extrato-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Tipo</th>
                  <th>Descrição</th>
                  <th>Valor</th>
                  <th>Saldo após</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(mov, idx) in extratoSaldoAppsRevenda"
                  :key="`mov_${idx}`"
                >
                  <td>{{ formatarDataMovimentacaoSaldo(mov.created_at || mov.data_movimentacao || mov.date) }}</td>
                  <td>{{ textoTipoMovimentacaoSaldo(mov) }}</td>
                  <td>{{ mov.description || mov.descricao || mov.observacao || mov.observation || "Sem descrição" }}</td>
                  <td>
                    <span
                      class="saldo-mov-valor"
                      :class="classeValorMovimentacaoSaldo(mov)"
                    >
                      {{ sinalValorMovimentacaoSaldo(mov) }} {{ formatarMoedaLicenca(mov.amount ?? mov.valor ?? mov.value ?? 0) }}
                    </span>
                  </td>
                  <td>{{ formatarMoedaLicenca(mov.balance_after ?? mov.saldo_apos ?? mov.balanceAfter ?? 0) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-upload-pdv-offline"
      :title="
        revendaUploadPdvSelecionada
          ? 'Upload PDV Offline — ' + revendaUploadPdvSelecionada.nome
          : 'Upload PDV Offline'
      "
      hide-footer
      centered
    >
      <div v-if="revendaUploadPdvSelecionada">
        <p class="mb-3">
          Revenda: <strong>{{ revendaUploadPdvSelecionada.nome }}</strong>
        </p>

        <b-form-group label="Nome do arquivo" label-for="upload-pdv-nome-arquivo">
          <b-form-input
            id="upload-pdv-nome-arquivo"
            v-model.trim="formUploadPdv.nome_arquivo"
            placeholder="Ex: Nuts-PDV-Desktop-parceiro.exe"
          />
        </b-form-group>

        <b-form-group label="Arquivo do instalador (.exe)" label-for="upload-pdv-arquivo">
          <b-form-file
            id="upload-pdv-arquivo"
            accept=".exe"
            placeholder="Selecione o instalador .exe..."
            @change="setArquivoUploadPdv"
          />
        </b-form-group>

        <div v-if="erroUploadPdv" class="text-danger font-weight-bold mb-3">
          {{ erroUploadPdv }}
        </div>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            :disabled="enviandoUploadPdv"
            @click="$bvModal.hide('modal-upload-pdv-offline')"
          >
            Cancelar
          </b-button>

          <b-button
            variant="primary"
            :disabled="enviandoUploadPdv || !formUploadPdv.arquivo"
            @click="enviarUploadPdvOffline"
          >
            <b-spinner small class="mr-2" v-if="enviandoUploadPdv"></b-spinner>
            {{ enviandoUploadPdv ? "Enviando..." : "Enviar" }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-features-empresa"
      :title="
        empresaFeaturesSelecionada
          ? 'Gerenciar Apps — ' + empresaFeaturesSelecionada.nome
          : 'Gerenciar Apps'
      "
      hide-footer
      centered
      size="xl"
    >
      <div class="feature-admin-modal">
        <div class="feature-admin-header mb-3">
          <p class="mb-1">
            Cliente:
            <strong>{{
              empresaFeaturesSelecionada
                ? empresaFeaturesSelecionada.nome
                : "Não informado"
            }}</strong>
          </p>
          <p class="mb-1">
            CNPJ/CPF:
            <strong>{{ documentoEmpresaSelecionada }}</strong>
          </p>
          <p class="mb-0">
            Plano atual: <strong>{{ planoAtualEmpresaSelecionada }}</strong>
          </p>
        </div>

        <div class="alert alert-light-warning py-2 px-3 mb-3">
          Esta liberação é administrativa e não gera cobrança automática.
        </div>


        <div class="feature-admin-content">
          <div v-if="loadingFeatures" class="text-center py-5">
            <b-spinner variant="primary" label="Carregando..." />
            <p class="mt-3 text-muted">Carregando módulos e plugins...</p>
          </div>

          <div v-else-if="erroFeatures" class="text-center py-5 text-muted">
            {{ erroFeatures }}
          </div>

          <div
            v-else-if="!featuresFiltradas.length"
            class="text-center py-5 text-muted"
          >
            Nenhum módulo ou plugin encontrado para sua busca.
          </div>

          <div v-else>
            <div v-if="featuresAgrupadas.modules.length" class="mb-4">
              <h6 class="feature-admin-group-title">Módulos</h6>

              <div class="feature-grid">
                <div
                  v-for="feature in featuresAgrupadas.modules"
                  :key="feature.code"
                  class="feature-admin-item border rounded"
                  :class="{ ativo: feature.active, 'em-breve': isComingSoon(feature) }"
                >
                  <div class="feature-item-top">
                    <div class="d-flex align-items-start feature-admin-main">
                      <b-form-checkbox
                        v-model="feature.active"
                        switch
                        class="mr-3 mt-1"
                        :disabled="isComingSoon(feature)"
                        @change="aoAlterarFeatureAtiva(feature)"
                      />

                      <div class="feature-admin-body">
                        <div class="d-flex align-items-center flex-wrap mb-1">
                          <h6 class="mb-0 mr-2 font-weight-bold">
                            {{ feature.name }}
                          </h6>
                          <span class="label label-inline mr-2 label-light-success">
                            Módulo
                          </span>
                          <span
                            v-if="isComingSoon(feature)"
                            class="label label-inline mr-2 label-warning em-breve-badge"
                          >
                            Em breve
                          </span>
                          <span
                            v-if="feature.active"
                            class="label label-inline label-light-primary"
                          >
                            Ativo
                          </span>
                        </div>

                        <p class="text-muted mb-2 feature-description">
                          {{ feature.description || "Sem descrição cadastrada." }}
                        </p>

                        <div class="feature-admin-meta">
                          <span>
                            Valor referência:
                            <strong>{{ formatarValorMensalFeature(feature) }}</strong>
                          </span>
                          <span>
                            Cobrança:
                            <strong>{{ textoBillingMode(feature.billing_mode) }}</strong>
                          </span>
                          <span v-if="feature.active">
                            <span
                              class="feature-source-badge"
                              :class="classeSourceFeature(feature.source)"
                            >
                              {{ textoSourceFeature(feature.source) }}
                            </span>
                          </span>
                        </div>

                        <div class="feature-admin-controls mt-3">
                          <b-form-group
                            label="Tipo de liberação"
                            class="mb-2"
                            label-class="mb-1"
                          >
                            <b-form-select
                              v-model="feature.tipo_liberacao"
                              :disabled="isComingSoon(feature) || !feature.active"
                              :options="opcoesLiberacaoFeatures"
                              @change="atualizarLiberacaoFeature(feature)"
                            />
                          </b-form-group>

                          <small class="text-muted d-block">
                            {{ descricaoLiberacaoFeature(feature) }}
                          </small>

                          <small
                            v-if="feature.renewal_behavior === 'charge_on_renewal'"
                            class="text-warning d-block mt-1"
                          >
                            Na renovação, o cliente deverá contratar para continuar usando.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="featuresAgrupadas.plugins.length" class="mb-2">
              <h6 class="feature-admin-group-title">Plugins</h6>

              <div class="feature-grid">
                <div
                  v-for="feature in featuresAgrupadas.plugins"
                  :key="feature.code"
                  class="feature-admin-item border rounded"
                  :class="{ ativo: feature.active, 'em-breve': isComingSoon(feature) }"
                >
                  <div class="feature-item-top">
                    <div class="d-flex align-items-start feature-admin-main">
                      <b-form-checkbox
                        v-model="feature.active"
                        switch
                        class="mr-3 mt-1"
                        :disabled="isComingSoon(feature)"
                        @change="aoAlterarFeatureAtiva(feature)"
                      />

                      <div class="feature-admin-body">
                        <div class="d-flex align-items-center flex-wrap mb-1">
                          <h6 class="mb-0 mr-2 font-weight-bold">
                            {{ feature.name }}
                          </h6>
                          <span class="label label-inline mr-2 label-light-primary">
                            Plugin
                          </span>
                          <span
                            v-if="isComingSoon(feature)"
                            class="label label-inline mr-2 label-warning em-breve-badge"
                          >
                            Em breve
                          </span>
                          <span
                            v-if="feature.active"
                            class="label label-inline label-light-primary"
                          >
                            Ativo
                          </span>
                        </div>

                        <p class="text-muted mb-2 feature-description">
                          {{ feature.description || "Sem descrição cadastrada." }}
                        </p>

                        <div class="feature-admin-meta">
                          <span>
                            Valor referência:
                            <strong>{{ formatarValorMensalFeature(feature) }}</strong>
                          </span>
                          <span>
                            Cobrança:
                            <strong>{{ textoBillingMode(feature.billing_mode) }}</strong>
                          </span>
                          <span v-if="feature.active">
                            <span
                              class="feature-source-badge"
                              :class="classeSourceFeature(feature.source)"
                            >
                              {{ textoSourceFeature(feature.source) }}
                            </span>
                          </span>
                        </div>

                        <div
                          class="feature-quantity mt-3"
                          v-if="feature.billing_mode === 'per_quantity'"
                        >
                          <span class="feature-quantity-label">Quantidade</span>
                          <div class="feature-quantity-controls">
                            <button
                              type="button"
                              class="btn btn-sm btn-light-primary"
                              :disabled="isComingSoon(feature) || !feature.active || feature.quantity <= feature.min_quantity"
                              @click="alterarQuantidadeFeature(feature, -1)"
                            >
                              -
                            </button>
                            <span class="feature-quantity-value">{{ feature.quantity }}</span>
                            <button
                              type="button"
                              class="btn btn-sm btn-light-primary"
                              :disabled="isComingSoon(feature) || !feature.active"
                              @click="alterarQuantidadeFeature(feature, 1)"
                            >
                              +
                            </button>
                          </div>

                          <div class="text-muted mt-2">
                            Total referência:
                            <strong>{{ formatarTotalFeature(feature) }}</strong>
                          </div>
                        </div>

                        <div class="feature-admin-controls mt-3">
                          <b-form-group
                            label="Tipo de liberação"
                            class="mb-2"
                            label-class="mb-1"
                          >
                            <b-form-select
                              v-model="feature.tipo_liberacao"
                              :disabled="isComingSoon(feature) || !feature.active"
                              :options="opcoesLiberacaoFeatures"
                              @change="atualizarLiberacaoFeature(feature)"
                            />
                          </b-form-group>

                          <small class="text-muted d-block">
                            {{ descricaoLiberacaoFeature(feature) }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="feature-admin-footer">
          <div>
            <div class="font-weight-bold">{{ resumoAppsAtivos }} apps ativos</div>
            <div class="text-muted">
              Total referência: <strong>{{ totalReferenciaFormatado }}</strong>
            </div>
          </div>

          <div class="feature-admin-actions">
            <b-button
              variant="secondary"
              class="mr-2"
              :disabled="salvandoFeatures"
              @click="$bvModal.hide('modal-features-empresa')"
            >
              Cancelar
            </b-button>
            <b-button
              variant="primary"
              :disabled="salvandoFeatures || loadingFeatures || !!erroFeatures"
              @click="salvarFeatures"
            >
              <b-spinner small class="mr-2" v-if="salvandoFeatures"></b-spinner>
              {{ salvandoFeatures ? "Salvando alterações..." : "Salvar alterações" }}
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-uso-empresa"
      :title="
        empresaUsoSelecionada
          ? 'Análise de Uso — ' + empresaUsoSelecionada.nome
          : 'Análise de Uso'
      "
      hide-footer
      centered
      size="lg"
    >
      <div v-if="loadingUso" class="text-center py-5">
        <b-spinner variant="primary" label="Carregando..." />
        <p class="mt-3 text-muted">Carregando dados de uso...</p>
      </div>
      <div v-else-if="usoEmpresa">
        <div
          class="rounded p-4 mb-4 text-center"
          :style="{
            background:
              temperaturaUso.tipo === 'quente'
                ? 'linear-gradient(135deg, #ff6b35, #f7c59f)'
                : temperaturaUso.tipo === 'morno'
                ? 'linear-gradient(135deg, #f7b731, #ffe082)'
                : 'linear-gradient(135deg, #2980b9, #a8d8ea)',
            color: temperaturaUso.tipo === 'frio' ? '#fff' : '#333',
          }"
        >
          <div style="font-size: 48px; line-height: 1">
            {{
              temperaturaUso.tipo === "quente"
                ? "🔥"
                : temperaturaUso.tipo === "morno"
                ? "🌤️"
                : "❄️"
            }}
          </div>
          <h4 class="mt-2 mb-1 font-weight-bold">
            {{
              temperaturaUso.tipo === "quente"
                ? "Cliente Quente"
                : temperaturaUso.tipo === "morno"
                ? "Cliente Morno"
                : "Cliente Frio"
            }}
          </h4>
          <p class="mb-3 font-weight-bold">
            <template v-if="temperaturaUso.dias === null"
              >Sem atividade registrada</template
            >
            <template v-else-if="temperaturaUso.dias === 0"
              >Ativo hoje!</template
            >
            <template v-else
              >Última atividade há {{ temperaturaUso.dias }} dia(s)</template
            >
          </p>
          <div class="px-5">
            <div
              class="progress"
              style="
                height: 14px;
                border-radius: 7px;
                background: rgba(255, 255, 255, 0.35);
              "
            >
              <div
                class="progress-bar bg-white"
                :style="{ width: temperaturaScore + '%' }"
                role="progressbar"
              />
            </div>
            <div
              class="d-flex justify-content-between mt-1"
              style="font-size: 11px"
            >
              <span>❄️ Inativo</span>
              <span>Score de Uso: {{ temperaturaScore }}%</span>
              <span>🔥 Muito Ativo</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-6 mb-3"
            v-for="(item, idx) in metricasUso"
            :key="idx"
          >
            <div class="card border shadow-sm h-100">
              <div class="card-body p-3 d-flex align-items-center">
                <span
                  style="font-size: 26px; min-width: 38px; text-align: center"
                  >{{ item.icone }}</span
                >
                <div class="ml-3">
                  <div
                    class="text-muted"
                    style="
                      font-size: 11px;
                      text-transform: uppercase;
                      letter-spacing: 0.5px;
                    "
                  >
                    {{ item.label }}
                  </div>
                  <div v-if="item.valor">
                    <span
                      class="font-weight-bold"
                      :class="
                        item.dias <= 7
                          ? 'text-success'
                          : item.dias <= 30
                          ? 'text-warning'
                          : 'text-danger'
                      "
                    >
                      {{ diasDesde(item.valor) }}
                    </span>
                    <div class="text-muted" style="font-size: 11px">
                      {{ formatUsoDt(item.valor) }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="text-muted font-weight-bold"
                    style="font-size: 13px"
                  >
                    Nunca utilizado
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Eye from "vue-material-design-icons/Eye.vue";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import FilterFields from "@/components/FilterFields";
import Menu from "vue-material-design-icons/Menu";
import AppsIcon from "vue-material-design-icons/Apps.vue";
import CreditCard from "vue-material-design-icons/CreditCard.vue";
import LockOpen from "vue-material-design-icons/LockOpen.vue";
import Lock from "vue-material-design-icons/Lock.vue";
import Analytics from "vue-material-design-icons/GoogleAnalytics.vue";
import Cash from "vue-material-design-icons/Cash.vue";
import OfficeBuilding from "vue-material-design-icons/OfficeBuilding.vue";
import AccountGroup from "vue-material-design-icons/AccountGroup.vue";
import Briefcase from "vue-material-design-icons/Briefcase.vue";
import License from "vue-material-design-icons/License.vue";
import Medal from "vue-material-design-icons/Medal.vue";
import CloudUpload from "vue-material-design-icons/CloudUpload.vue";
import { filtersStore } from "@/components/FilterFields/filtersStore";

export default {
  name: "app-revendas",
  mixins: [SistemaMixin],
  components: {
    Eye,
    TableApp,
    FilterFields,
    Menu,
    AppsIcon,
    CreditCard,
    LockOpen,
    Lock,
    Analytics,
    Cash,
    OfficeBuilding,
    AccountGroup,
    Briefcase,
    License,
    Medal,
    CloudUpload,
  },
  data() {
    return {
      fields: [
        {
          label: "Cliente",
          field: "nome",
          type: "text",
          slot: true,
          sortable: true,
          width: "18%",
          filterOptions: {
            enabled: false,
            placeholder: "Pesquisar Nome/Razão Social",
          },
        },
        {
          label: "Documento",
          field: "cnpj_cpf",
          type: "text",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Licença",
          field: "data_validade",
          type: "text",
          slot: true,
          sortable: false,
          width: "21%",
          dateInputFormat: "DD/MM/YYYY",
          dateOutputFormat: "YYYY-MM-DD",
        },
        {
          label: "Apps",
          field: "apps",
          slot: true,
          width: "12%",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Revenda",
          field: "revenda_info",
          slot: true,
          width: "11%",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Status",
          field: "status",
          slot: true,
          width: "8%",
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
      filtersStore,
      buscaRapida: "",
      filtroRapidoSelecionado: "todos",
      filtrosRapidosTabela: [
        { value: "clientes", text: "Clientes" },
        { value: "revendas", text: "Revendas" },
      ],
      metricasPainel: {
        totalClientes: 0,
        ativos: 0,
        bloqueados: 0,
        comApps: 0,
        receitaAnual: 0,
        mensalRecorrente: 0,
      },
      resumoRevenda: {
        nome: "Visão Nuts",
        telefone: "Não informado",
        cidadeUf: "Não informado",
      },
      revendaSaldoSelecionada: null,
      loadingSaldoAppsRevenda: false,
      erroSaldoAppsRevenda: null,
      salvandoCreditoApps: false,
      saldoAppsRevenda: {
        disponivel: 0,
        usado: 0,
        creditado: 0,
      },
      formCreditoApps: {
        valor: null,
        observacao: "",
      },
      extratoSaldoAppsRevenda: [],
      revendaUploadPdvSelecionada: null,
      formUploadPdv: {
        arquivo: null,
        nome_arquivo: "",
      },
      enviandoUploadPdv: false,
      erroUploadPdv: null,
      clienteAppsSelecionado: null,
      clientePlanoSelecionado: null,
      formPlano: {
        id_plan: null,
        data_validade: null,
      },
      salvandoPlano: false,
      opcoesPlanos: [
        { value: 1, text: "Free" },
        { value: 2, text: "Essencial Anual" },
        { value: 3, text: "Essencial Mensal" },
        { value: 4, text: "Standard Mensal" },
        { value: 6, text: "Standard Anual" },
        { value: 7, text: "Basic" },
      ],
      formFaturamento: {
        data_inicio: null,
        data_fim: null,
      },
      empresaUsoSelecionada: null,
      usoEmpresa: null,
      loadingUso: false,
      empresaUsuariosSelecionada: null,
      usuariosEmpresa: [],
      loadingUsuarios: false,
      erroUsuarios: null,
      usuarioSenhaSelecionado: null,
      formSenha: {
        password: "",
        password_confirmation: "",
      },
      salvandoSenha: false,
      empresaFeaturesSelecionada: null,
      featuresEmpresa: [],
      loadingFeatures: false,
      erroFeatures: null,
      salvandoFeatures: false,
      buscaFeatures: "",
      filtroRapidoFeatures: "all",
      filtrosRapidosFeatures: [
        { value: "all", text: "Todos" },
        { value: "module", text: "Módulos" },
        { value: "plugin", text: "Plugins" },
        { value: "active", text: "Ativos" },
        { value: "inactive", text: "Inativos" },
        { value: "per_quantity", text: "Por quantidade" },
        { value: "coming_soon", text: "Em breve" },
      ],
      opcoesLiberacaoFeatures: [
        { value: "charge_on_renewal", text: "Cortesia até a renovação" },
        { value: "keep_free", text: "Gratuito permanente" },
        { value: "expire_on_renewal", text: "Temporário até a renovação" },
      ],
    };
  },
  methods: {
    async abrirModalUsuarios(empresa) {
      this.empresaUsuariosSelecionada = empresa;
      this.usuariosEmpresa = [];
      this.erroUsuarios = null;
      this.loadingUsuarios = true;
      this.$bvModal.show("modal-usuarios-empresa");

      try {
        const response = await this.$http.get(
          `/admin/empresas/${empresa.id_empresa}/usuarios`
        );
        this.usuariosEmpresa = response.data.data || [];
      } catch (error) {
        this.erroUsuarios =
          error.response?.data?.msg || "Não foi possível carregar os usuários da empresa.";
      } finally {
        this.loadingUsuarios = false;
      }
    },
    abrirAlteracaoSenha(usuario) {
      this.usuarioSenhaSelecionado = usuario;
      this.formSenha = {
        password: "",
        password_confirmation: "",
      };
      this.$bvModal.show("modal-alterar-senha-usuario");
    },
    async salvarSenhaUsuario() {
      if (!this.formSenha.password || this.formSenha.password.length < 4) {
        this.$toast.warning("A nova senha deve conter pelo menos 4 caracteres.");
        return;
      }

      if (this.formSenha.password !== this.formSenha.password_confirmation) {
        this.$toast.warning("A confirmação da nova senha não confere.");
        return;
      }

      this.salvandoSenha = true;

      try {
        await this.$http.patch(
          `/admin/empresas/${this.empresaUsuariosSelecionada.id_empresa}/usuarios/${this.usuarioSenhaSelecionado.id_usuario}/senha`,
          this.formSenha
        );
        this.$toast.success("Senha alterada com sucesso!");
        this.$bvModal.hide("modal-alterar-senha-usuario");
      } catch (error) {
        const erroValidacao = error.response?.data?.errors?.password?.[0];
        this.$toast.error(
          erroValidacao || error.response?.data?.msg || "Não foi possível alterar a senha."
        );
      } finally {
        this.salvandoSenha = false;
      }
    },
    garantirFiltroStoreAtual() {
      if (!this.filtersStore[this.moduleName]) {
        this.filtersStore[this.moduleName] = {
          filters: {},
          per_page: 10,
          page: 1,
        };
      }
    },
    atualizarResumoPainel(payload) {
      const linhas = Array.isArray(payload?.rows) ? payload.rows : [];
      const total = Number(payload?.total || 0);

      const ativos = linhas.filter((row) => !this.clienteBloqueado(row)).length;
      const bloqueados = linhas.filter((row) => this.clienteBloqueado(row)).length;
      const comApps = linhas.filter((row) => this.totalAppsAtivosLicenca(row) > 0).length;
      const receitaAnual = linhas.reduce(
        (acc, row) => acc + this.totalAnualLicenca(row),
        0
      );
      const mensalRecorrente = linhas.reduce(
        (acc, row) => acc + this.totalMensalRecorrenteLicenca(row),
        0
      );

      this.metricasPainel = {
        totalClientes: total,
        ativos,
        bloqueados,
        comApps,
        receitaAnual,
        mensalRecorrente,
      };

      const primeiraLinha = linhas[0] || {};
      this.resumoRevenda = {
        nome: primeiraLinha.revenda_nome || "Visão Nuts",
        telefone: primeiraLinha.revenda_fone || "Não informado",
        cidadeUf: [primeiraLinha.revenda_cidade, primeiraLinha.revenda_uf]
          .filter(Boolean)
          .join(" - ") || "Não informado",
      };
    },
    registrarResumoLinha(row) {
      return row?.id_empresa || "";
    },
    clienteBloqueado(row) {
      return row?.bloqueado === true;
    },
    aplicarBuscaRapida() {
      this.garantirFiltroStoreAtual();
      const filtros = {
        ...(this.filtersStore[this.moduleName]?.filters || {}),
      };

      if (this.buscaRapida) {
        filtros.nome = this.buscaRapida;
      } else {
        delete filtros.nome;
      }

      this.filtersStore[this.moduleName].filters = filtros;
      this.filtersStore[this.moduleName].page = 1;
      this.$refs.clientes?.refresh();
    },
    aplicarFiltroRapidoTabela(filtro) {
      this.garantirFiltroStoreAtual();
      this.filtroRapidoSelecionado = filtro;
      const filtros = {
        ...(this.filtersStore[this.moduleName]?.filters || {}),
      };

      delete filtros.status;
      delete filtros.bloqueado;
      delete filtros.tipo;
      delete filtros.com_apps;
      delete filtros.sem_apps;

      if (filtro === "clientes") filtros.tipo = "Cliente";
      if (filtro === "revendas") filtros.tipo = "Revenda";

      this.filtersStore[this.moduleName].filters = filtros;
      this.filtersStore[this.moduleName].page = 1;
      this.$refs.clientes?.refresh();
    },
    cidadeUfCliente(row) {
      const cidade = row?.cidade || row?.cliente_cidade || row?.empresa_cidade;
      const uf = row?.uf || row?.cliente_uf || row?.empresa_uf;

      if (cidade && uf) return `${cidade} - ${uf}`;
      return cidade || uf || "Cidade não informada";
    },
    nivelPartnerRevendaNumero(row) {
      const nivel =
        row?.nivel_revenda?.nivel ??
        row?.empresa?.nivel_revenda?.nivel ??
        row?.dados_revenda?.nivel_revenda?.nivel ??
        row?.nivel_partner?.nivel ??
        row?.nivel_parceiro?.nivel ??
        row?.partner_level?.nivel ??
        row?.revenda_nivel?.nivel ??
        row?.nivel_partner ??
        row?.nivel_parceiro ??
        row?.partner_level ??
        row?.revenda_nivel ??
        row?.nivel;

      const nivelNumero = Number(nivel);
      return Number.isFinite(nivelNumero) ? nivelNumero : null;
    },
    nivelPartnerRevenda(row) {
      const nivel =
        row?.nivel_revenda?.nivel ??
        row?.empresa?.nivel_revenda?.nivel ??
        row?.dados_revenda?.nivel_revenda?.nivel ??
        row?.nivel_partner?.nivel ??
        row?.nivel_parceiro?.nivel ??
        row?.partner_level?.nivel ??
        row?.revenda_nivel?.nivel ??
        row?.nivel_partner ??
        row?.nivel_parceiro ??
        row?.partner_level ??
        row?.revenda_nivel ??
        row?.nivel;

      if (nivel === null || nivel === undefined || nivel === "") {
        return "Não informado";
      }

      const nivelNumero = Number(nivel);
      const niveis = {
        1: "Start",
        2: "Prime",
        3: "Pró",
        4: "Elite",
        5: "Supreme",
      };

      if (Number.isFinite(nivelNumero) && niveis[nivelNumero]) {
        return `${nivelNumero} - ${niveis[nivelNumero]}`;
      }

      return String(nivel);
    },
    totalLicencasRevenda(row) {
      const licencaRevenda =
        row?.empresa?.licenca_revenda ||
        row?.licenca_revenda ||
        row?.dados_revenda?.licenca_revenda ||
        {};
      const total =
        licencaRevenda?.total ??
        licencaRevenda?.quantidade ??
        licencaRevenda?.qtd ??
        row?.total_licencas ??
        row?.quantidade_licencas ??
        row?.qtd_licencas ??
        row?.licencas ??
        row?.licencas_total;

      if (total === null || total === undefined || total === "") {
        return "Não informado";
      }

      const numero = Number(total);
      return Number.isFinite(numero) ? numero : total;
    },
    resumoAppsLicenca(row) {
      const itens = this.resumoLicenca(row).apps.itens;
      if (!itens.length) return "";

      const nomes = itens
        .map((item) => this.nomeAppDetalheLicenca(item))
        .filter(Boolean)
        .slice(0, 3);
      const restante = itens.length - nomes.length;

      return `${nomes.join(", ")}${restante > 0 ? ` +${restante} app` : ""}`;
    },
    abrirModalAppsLicenca(row) {
      this.clienteAppsSelecionado = row;
      this.$bvModal.show("modal-apps-licenca");
    },
    nomeAppDetalheLicenca(item) {
      return (
        item.nome || item.name || item.titulo || item.title || item.codigo || item.code || "App"
      );
    },
    tipoAppDetalheLicenca(item) {
      const tipo = String(item.type || item.tipo || "module").toLowerCase();
      return tipo === "plugin" ? "Plugin" : "Módulo";
    },
    origemAppDetalheLicenca(item) {
      const origem = item.source || item.origem || "manual";
      const mapa = {
        renewal: "Renovação",
        marketplace: "Marketplace",
        checkout: "Marketplace",
        manual: "Manual",
        legacy: "Legado",
        revenda: "Revenda",
      };

      return mapa[origem] || origem;
    },
    valorAppDetalheLicenca(item) {
      const quantidade = Math.max(1, Number(item.quantity || item.quantidade || 1));
      const unitario = this.primeiroValorNumericoLicenca(
        item.unit_price,
        item.valor_unitario,
        item.monthly_price,
        item.valor_mensal
      );
      const totalMensal = this.primeiroValorNumericoLicenca(
        item.total_price,
        item.total_mensal,
        item.mensal_total
      );
      const totalAnual = this.primeiroValorNumericoLicenca(
        item.total_price,
        item.total_anual,
        item.anual_total,
        item.annual_price,
        item.valor_anual
      );
      const ciclo = String(item.billing_cycle || "").toLowerCase();

      if (ciclo === "yearly") {
        return `${this.formatarMoedaLicenca(totalAnual)}/ano`;
      }

      if (quantidade > 1 && unitario > 0) {
        return `${quantidade} x ${this.formatarMoedaLicenca(unitario)} = ${this.formatarMoedaLicenca(totalMensal)}/mês`;
      }

      return `${this.formatarMoedaLicenca(totalMensal)}/mês`;
    },
    formatarDataMovimentacaoSaldo(data) {
      if (!data) return "--";
      return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    textoTipoMovimentacaoSaldo(mov) {
      const tipo = String(
        mov.movement_type || mov.type || mov.tipo || ""
      ).toLowerCase();
      if (["credit", "credito", "crédito"].includes(tipo)) return "Crédito";
      if (["debit", "debito", "débito"].includes(tipo)) return "Débito";
      return mov.movement_type || mov.type || mov.tipo || "Movimentação";
    },
    classeValorMovimentacaoSaldo(mov) {
      const tipo = String(
        mov.movement_type || mov.type || mov.tipo || ""
      ).toLowerCase();
      return ["credit", "credito", "crédito"].includes(tipo)
        ? "saldo-mov-credito"
        : "saldo-mov-debito";
    },
    sinalValorMovimentacaoSaldo(mov) {
      const tipo = String(
        mov.movement_type || mov.type || mov.tipo || ""
      ).toLowerCase();
      return ["credit", "credito", "crédito"].includes(tipo) ? "+" : "-";
    },
    async abrirModalSaldoApps(row) {
      if (!row?.revenda || !this.currentUser?.admin || !this.isNuts) {
        return;
      }

      this.revendaSaldoSelecionada = {
        id_revenda: row.id_empresa,
        nome: row.nome || row.revenda_nome || "Revenda",
        cnpj_cpf: row.cnpj_cpf || row.revenda_cnpj || null,
      };
      this.erroSaldoAppsRevenda = null;
      this.formCreditoApps.valor = null;
      this.formCreditoApps.observacao = "";
      this.extratoSaldoAppsRevenda = [];
      this.saldoAppsRevenda = { disponivel: 0, usado: 0, creditado: 0 };
      this.$bvModal.show("modal-saldo-apps-revenda");
      await this.carregarSaldoAppsRevenda();
    },
    async carregarSaldoAppsRevenda() {
      if (!this.revendaSaldoSelecionada?.id_revenda) return;

      this.loadingSaldoAppsRevenda = true;
      this.erroSaldoAppsRevenda = null;
      try {
        const idRevenda = this.revendaSaldoSelecionada.id_revenda;
        const response = await this.$http.get(
          `/admin/revendas/${idRevenda}/app-wallet`
        );

        const data = response?.data?.data ?? response?.data ?? {};
        const wallet = data.wallet || data;
        const revenda = data.revenda || {};

        this.revendaSaldoSelecionada = {
          ...this.revendaSaldoSelecionada,
          id_revenda: revenda.id_empresa || this.revendaSaldoSelecionada.id_revenda,
          nome: revenda.nome || this.revendaSaldoSelecionada.nome,
          cnpj_cpf: revenda.cnpj_cpf ?? this.revendaSaldoSelecionada.cnpj_cpf,
        };

        this.saldoAppsRevenda = {
          disponivel: this.valorNumericoLicenca(
            wallet.available_balance ??
              wallet.saldo_disponivel ??
              wallet.disponivel ??
              0
          ),
          usado: this.valorNumericoLicenca(
            wallet.used_balance ?? wallet.saldo_usado ?? wallet.usado ?? 0
          ),
          creditado: this.valorNumericoLicenca(
            wallet.total_credited ??
              wallet.total_creditado ??
              wallet.saldo_total_creditado ??
              wallet.creditado ??
              0
          ),
        };
        this.extratoSaldoAppsRevenda = Array.isArray(data.movements)
          ? data.movements
          : Array.isArray(data.extrato)
          ? data.extrato
          : Array.isArray(data.transactions)
          ? data.transactions
          : Array.isArray(data.movimentacoes)
          ? data.movimentacoes
          : [];
      } catch (e) {
        this.erroSaldoAppsRevenda = "Não foi possível carregar o saldo da revenda.";
      } finally {
        this.loadingSaldoAppsRevenda = false;
      }
    },
    async adicionarCreditoAppsRevenda() {
      if (!this.revendaSaldoSelecionada?.id_revenda) return;

      const valor = this.valorNumericoLicenca(this.formCreditoApps.valor);
      if (valor <= 0) {
        this.$toast.warning("Informe um valor de crédito válido.");
        return;
      }

      this.salvandoCreditoApps = true;
      try {
        const idRevenda = this.revendaSaldoSelecionada.id_revenda;

        await this.$http.post(
          `/admin/revendas/${idRevenda}/app-wallet/credit`,
          {
            amount: valor,
            description: this.formCreditoApps.observacao || null,
          }
        );

        this.$toast.success("Crédito adicionado com sucesso!");
        this.formCreditoApps.valor = null;
        this.formCreditoApps.observacao = "";
        await this.carregarSaldoAppsRevenda();
      } catch (e) {
        this.$toast.error("Não foi possível adicionar o crédito da revenda.");
      } finally {
        this.salvandoCreditoApps = false;
      }
    },
    abrirModalUploadPdvOffline(row) {
      const nome = row.nome || row.revenda_nome || "Revenda";
      const slug = String(nome)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

      this.revendaUploadPdvSelecionada = {
        id_revenda: row.id_empresa,
        nome,
      };
      this.formUploadPdv = {
        arquivo: null,
        nome_arquivo: `Nuts-PDV-Desktop-${slug || "parceiro"}.exe`,
      };
      this.erroUploadPdv = null;
      this.$bvModal.show("modal-upload-pdv-offline");
    },
    setArquivoUploadPdv(event) {
      const arquivo = event?.target?.files?.[0] || null;

      if (arquivo && !/\.exe$/i.test(arquivo.name)) {
        this.erroUploadPdv = "Selecione um arquivo com extensão .exe";
        this.formUploadPdv.arquivo = null;
        event.target.value = "";
        return;
      }

      this.erroUploadPdv = null;
      this.formUploadPdv.arquivo = arquivo;
    },
    async enviarUploadPdvOffline() {
      if (!this.revendaUploadPdvSelecionada?.id_revenda) return;
      if (!this.formUploadPdv.arquivo) {
        this.$toast.warning("Selecione o arquivo .exe do instalador.");
        return;
      }

      this.enviandoUploadPdv = true;
      this.erroUploadPdv = null;
      try {
        const dados = new FormData();
        dados.append("arquivo", this.formUploadPdv.arquivo);
        dados.append("id_revenda", this.revendaUploadPdvSelecionada.id_revenda);
        dados.append(
          "nome_arquivo",
          this.formUploadPdv.nome_arquivo || this.formUploadPdv.arquivo.name
        );

        await this.$http.post("/empresa/upload-pdv-offline", dados);

        this.$toast.success("Instalador enviado com sucesso!");
        this.$bvModal.hide("modal-upload-pdv-offline");
      } catch (e) {
        const msg =
          e.response && e.response.data && e.response.data.msg
            ? e.response.data.msg
            : "Não foi possível enviar o instalador.";
        this.erroUploadPdv = msg;
        this.$toast.error(msg);
      } finally {
        this.enviandoUploadPdv = false;
      }
    },
    abrirModalPlano(row) {
      this.clientePlanoSelecionado = row;
      this.formPlano.id_plan = row.id_plan;
      this.formPlano.data_validade = row.data_validade;
      this.$bvModal.show("modal-alterar-plano");
    },
    async salvarPlano() {
      this.salvandoPlano = true;

      try {
        const payload = {
          id_empresa: this.clientePlanoSelecionado.id_empresa,
          id_plan: this.formPlano.id_plan,
          data_validade: this.formPlano.data_validade,
        };

        await this.$http.post("/empresa/atualizar-plano", payload);

        this.clientePlanoSelecionado.id_plan = this.formPlano.id_plan;
        this.clientePlanoSelecionado.data_validade =
          this.formPlano.data_validade;

        this.$toast.success("Plano alterado com sucesso!");
        this.$bvModal.hide("modal-alterar-plano");
        this.$refs.clientes.refresh();
      } catch (e) {
        this.$toast.error("Erro ao alterar plano.");
      } finally {
        this.salvandoPlano = false;
      }
    },
    async abrirModalFeatures(row) {
      this.empresaFeaturesSelecionada = row;
      this.featuresEmpresa = [];
      this.buscaFeatures = "";
      this.filtroRapidoFeatures = "all";
      this.erroFeatures = null;
      this.loadingFeatures = true;
      this.$bvModal.show("modal-features-empresa");

      try {
        const result = await this.$http.get(
          `/admin/empresas/${row.id_empresa}/features`
        );
        const response = result.data?.data ?? result.data ?? {};
        const features = Array.isArray(response)
          ? response
          : response.features || response.items || [];
        const validadePlano =
          response.data_validade ||
          response.plan_expires_at ||
          response.renewal_date ||
          row.data_validade;

        this.featuresEmpresa = features.map((feature) =>
          this.normalizarFeatureEmpresa(feature, validadePlano)
        );
      } catch (e) {
        this.erroFeatures = "Não foi possível carregar os apps desta empresa.";
      } finally {
        this.loadingFeatures = false;
      }
    },
    normalizarFeatureEmpresa(feature, validadePlano) {
      const cadastro = feature.feature || {};
      const renewalBehavior = feature.renewal_behavior || "charge_on_renewal";
      const source = feature.source || "manual";
      const billingMode =
        feature.billing_mode || cadastro.billing_mode || "flat";
      const status = String(feature.status || cadastro.status || "").toLowerCase();
      const available = this.normalizarBooleanFeature(
        feature.available ??
          feature.disponivel ??
          cadastro.available ??
          cadastro.disponivel,
        true
      );
      const comingSoon = this.isComingSoon({
        available,
        status,
      });
      const minQuantity = Math.max(
        1,
        Number(
          feature.min_quantity ||
            feature.minimo_quantidade ||
            cadastro.min_quantity ||
            cadastro.minimo_quantidade ||
            1
        )
      );
      const quantity = Number(feature.quantity || feature.quantidade || minQuantity);
      const type = String(
        feature.type ||
          feature.tipo ||
          cadastro.type ||
          cadastro.tipo ||
          "module"
      ).toLowerCase();
      const tags = this.normalizarListaBusca(
        feature.tags ||
          feature.etiquetas ||
          cadastro.tags ||
          cadastro.etiquetas ||
          []
      );
      const recomendadoPara = this.normalizarListaBusca(
        feature.recommended_for ||
          feature.recomendado_para ||
          cadastro.recommended_for ||
          cadastro.recomendado_para ||
          []
      );

      return {
        code: feature.code || cadastro.code,
        active:
          !comingSoon &&
          this.normalizarBooleanFeature(
          feature.active ?? feature.ativo ?? feature.enabled ?? feature.liberado
          ),
        name:
          feature.name ||
          feature.nome ||
          cadastro.name ||
          cadastro.nome ||
          feature.code ||
          cadastro.code,
        type: type === "plugin" ? "plugin" : "module",
        description:
          feature.description ||
          feature.descricao ||
          cadastro.description ||
          cadastro.descricao ||
          "",
        monthly_price:
          feature.monthly_price ??
          feature.valor_mensal ??
          cadastro.monthly_price ??
          cadastro.valor_mensal ??
          null,
        billing_mode: billingMode,
        min_quantity: minQuantity,
        quantity:
          billingMode === "per_quantity"
            ? Math.max(minQuantity, quantity > 0 ? quantity : minQuantity)
            : 1,
        source,
        renewal_behavior: renewalBehavior,
        tipo_liberacao: renewalBehavior,
        status,
        available,
        comingSoon,
        tags,
        recommended_for: recomendadoPara,
        valid_until:
          feature.valid_until ||
          feature.expires_at ||
          feature.data_validade ||
          validadePlano ||
          null,
      };
    },
    normalizarListaBusca(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.filter(Boolean).map((item) => String(item));

      return String(value)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    },
    normalizarBooleanFeature(value, defaultValue = false) {
      if (value === null || value === undefined || value === "") {
        return defaultValue;
      }

      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      if (typeof value === "string") {
        const normalizado = value.toLowerCase().trim();
        if (["1", "true", "sim", "yes", "ativo"].includes(normalizado)) {
          return true;
        }
        if (["0", "false", "nao", "não", "no", "inativo"].includes(normalizado)) {
          return false;
        }
      }

      return defaultValue;
    },
    isComingSoon(app) {
      if (!app) return false;

      const status = String(app.status || "").toLowerCase();

      return (
        app.available === false ||
        status === "coming_soon" ||
        status === "unavailable"
      );
    },
    aoAlterarFeatureAtiva(feature) {
      if (this.isComingSoon(feature)) {
        feature.active = false;
        this.$toast.warning(
          "Este módulo/plugin ainda não está disponível para liberação."
        );
        return;
      }

      if (!feature.active) {
        if (feature.billing_mode !== "per_quantity") {
          feature.quantity = 1;
        }
        return;
      }

      if (!feature.tipo_liberacao) {
        feature.tipo_liberacao = "charge_on_renewal";
      }

      feature.source = "manual";
      feature.renewal_behavior = feature.tipo_liberacao;

      if (feature.billing_mode === "per_quantity") {
        feature.quantity = Math.max(1, Number(feature.min_quantity || 1));
        return;
      }

      if (!feature.quantity || feature.quantity < 1) {
        feature.quantity = 1;
      }
    },
    atualizarLiberacaoFeature(feature) {
      if (this.isComingSoon(feature)) {
        feature.active = false;
        feature.tipo_liberacao = feature.renewal_behavior || "charge_on_renewal";
        return;
      }

      if (feature.active) {
        feature.source = "manual";
      }
      feature.renewal_behavior = feature.tipo_liberacao || "charge_on_renewal";
    },
    alterarQuantidadeFeature(feature, variacao) {
      if (!feature.active || this.isComingSoon(feature)) return;

      const minQuantity = Math.max(1, Number(feature.min_quantity || 1));
      const atual = Math.max(minQuantity, Number(feature.quantity || minQuantity));
      feature.quantity = Math.max(minQuantity, atual + variacao);
    },
    descricaoLiberacaoFeature(feature) {
      const descricoes = {
        charge_on_renewal:
          "O cliente usa agora sem cobrança. Na renovação, deverá contratar/pagar para continuar.",
        keep_free: "O cliente mantém este app liberado sem cobrança.",
        expire_on_renewal:
          "O app expira no vencimento do plano se não houver nova liberação.",
      };

      return (
        descricoes[feature.renewal_behavior] || descricoes.charge_on_renewal
      );
    },
    textoSourceFeature(source) {
      const sources = {
        manual: "Liberado manualmente",
        marketplace: "Contratado no Marketplace",
        legacy: "Legado / incluso",
        renewal: "Renovado junto ao plano",
        revenda: "Liberado pela revenda",
        checkout: "Contratado no Marketplace",
      };

      return sources[source] || source || "Liberado manualmente";
    },
    classeSourceFeature(source) {
      const classes = {
        manual: "badge-manual",
        marketplace: "badge-marketplace",
        legacy: "badge-legacy",
        renewal: "badge-renewal",
        revenda: "badge-revenda",
        checkout: "badge-marketplace",
      };

      return classes[source] || "badge-manual";
    },
    textoBillingMode(billingMode) {
      if (billingMode === "per_quantity") return "Por quantidade";
      return "Fixo mensal";
    },
    formatarValorMensalFeature(feature) {
      const valor = Number(feature.monthly_price || 0);
      const texto = this.numberToReal(valor, 2);

      if (feature.billing_mode === "per_quantity") {
        return `${texto}/mês por unidade`;
      }

      return `${texto}/mês`;
    },
    formatarTotalFeature(feature) {
      const valorUnitario = Number(feature.monthly_price || 0);
      const quantidade =
        feature.billing_mode === "per_quantity"
          ? Math.max(1, Number(feature.quantity || feature.min_quantity || 1))
          : 1;

      return `${this.numberToReal(valorUnitario * quantidade, 2)}/mês`;
    },
    obterPlanoPorId(idPlan) {
      const plano = this.opcoesPlanos.find(
        (item) => Number(item.value) === Number(idPlan)
      );

      return plano ? plano.text : "Não informado";
    },
    deveUsarValorRevenda(row) {
      const idRevenda = Number(row?.id_revenda || row?.revenda_id || 0);
      const nomeRevenda = String(row?.revenda_nome || "").toLowerCase().trim();
      const temRevendaNome =
        nomeRevenda && !["nuts", "visao nuts", "visão nuts"].includes(nomeRevenda);

      return Boolean(
        row?.revenda ||
          row?.isClienteRevenda ||
          row?.is_cliente_revenda ||
          temRevendaNome ||
          row?.dados_revenda ||
          row?.empresa?.dados_revenda ||
          (idRevenda && idRevenda !== 1)
      );
    },
    primeiroValorDefinidoLicenca(...valores) {
      for (const valor of valores) {
        if (valor !== null && valor !== undefined && valor !== "") {
          return this.valorNumericoLicenca(valor);
        }
      }

      return null;
    },
    valorPlanoRevenda(row, resumo, plano) {
      return this.primeiroValorDefinidoLicenca(
        plano.valor_revenda_anual,
        plano.valor_anual_revenda,
        plano.revenda_valor_anual,
        plano.valor_revenda,
        plano.preco_revenda_anual,
        plano.preco_anual_revenda,
        resumo.plano_valor_revenda_anual,
        resumo.valor_plano_revenda_anual,
        resumo.valor_revenda_anual,
        resumo.valor_revenda,
        row?.valor_revenda_anual,
        row?.valor_anual_revenda,
        row?.plano_valor_revenda_anual,
        row?.valor_revenda,
        row?.empresa?.valor_revenda_anual,
        row?.empresa?.valor_anual_revenda,
        row?.empresa?.plano_valor_revenda_anual,
        row?.empresa?.valor_revenda
      );
    },
    resumoLicenca(row) {
      const resumo = row?.licenca_resumo || {};
      const plano = resumo.plano || {};
      const apps = resumo.apps || {};
      const totais = resumo.totais || {};
      const valorPlanoRevenda = this.deveUsarValorRevenda(row)
        ? this.valorPlanoRevenda(row, resumo, plano)
        : null;
      const valorPlanoResumo = this.valorNumericoLicenca(plano.valor_anual);
      const valorPlanoBase = this.valorNumericoLicenca(
        plano.base_valor_anual ?? resumo.plano_valor_anual ?? row?.valor ?? 0
      );
      const totalAnualApps = this.valorNumericoLicenca(apps.anual_total ?? 0);
      const totalMensalApps = this.valorNumericoLicenca(apps.mensal_total ?? 0);
      const totalAnualResumo = this.valorNumericoLicenca(
        totais.total_anual_licenca
      );
      const resumoInconsistente =
        valorPlanoResumo > 0 &&
        totalAnualResumo > 0 &&
        Math.abs(valorPlanoResumo + totalAnualApps - totalAnualResumo) > 0.01;
      const valorPlanoAnual =
        valorPlanoRevenda !== null
          ? valorPlanoRevenda
          : resumoInconsistente && valorPlanoBase > 0
          ? valorPlanoBase
          : valorPlanoResumo || valorPlanoBase;
      const totalAnualCalculado = valorPlanoAnual + totalAnualApps;

      return {
        plano: {
          nome: plano.nome || this.obterPlanoPorId(row?.id_plan),
          valor_anual: valorPlanoAnual,
          data_validade: plano.data_validade || row?.data_validade || null,
        },
        apps: {
          total_ativos: Number(apps.total_ativos || 0),
          anual_total: totalAnualApps,
          mensal_total: totalMensalApps,
          itens: Array.isArray(apps.itens) ? apps.itens : [],
        },
        totais: {
          total_anual_licenca:
            totalAnualResumo > 0 &&
            Math.abs(totalAnualResumo - totalAnualCalculado) <= 0.01
              ? totalAnualResumo
              : totalAnualCalculado,
          total_mensal_recorrente: this.valorNumericoLicenca(
            totais.total_mensal_recorrente ?? totalMensalApps
          ),
        },
      };
    },
    valorNumericoLicenca(valor) {
      if (valor === null || valor === undefined || valor === "") return 0;
      if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;

      const normalizado = String(valor)
        .replace(/[^\d,.-]/g, "")
        .replace(/\.(?=\d{3}(,|$))/g, "")
        .replace(",", ".");
      const numero = Number(normalizado);

      return Number.isFinite(numero) ? numero : 0;
    },
    primeiroValorNumericoLicenca(...valores) {
      for (const valor of valores) {
        const numero = this.valorNumericoLicenca(valor);
        if (numero > 0) return numero;
      }

      return 0;
    },
    formatarMoedaLicenca(valor) {
      return `R$ ${this.numberToReal(this.valorNumericoLicenca(valor), 2)}`;
    },
    nomePlanoLicenca(row) {
      return this.resumoLicenca(row).plano.nome || "Plano não informado";
    },
    siglaPlanoLicenca(row) {
      const siglasPorPlano = {
        1: "F",
        2: "EA",
        3: "EM",
        4: "SM",
        6: "SA",
        7: "B",
      };
      const siglaPorId = siglasPorPlano[Number(row?.id_plan)];

      if (siglaPorId) return siglaPorId;

      const nome = this.nomePlanoLicenca(row);
      const sigla = nome
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((parte) => parte.charAt(0))
        .join("")
        .toUpperCase();

      return sigla || "--";
    },
    dataValidadeLicenca(row) {
      const data = this.resumoLicenca(row).plano.data_validade;
      return data ? this.formatDate(data) : "";
    },
    valorAnualPlanoLicenca(row) {
      return this.resumoLicenca(row).plano.valor_anual;
    },
    totalAppsAtivosLicenca(row) {
      return this.resumoLicenca(row).apps.total_ativos;
    },
    totalAnualAppsLicenca(row) {
      return this.resumoLicenca(row).apps.anual_total;
    },
    totalMensalAppsLicenca(row) {
      return this.resumoLicenca(row).apps.mensal_total;
    },
    totalAnualLicenca(row) {
      return this.resumoLicenca(row).totais.total_anual_licenca;
    },
    totalMensalRecorrenteLicenca(row) {
      return this.resumoLicenca(row).totais.total_mensal_recorrente;
    },
    tooltipAppsLicenca(row) {
      const itens = this.resumoLicenca(row).apps.itens;

      if (!itens.length) return "Apps ativos";

      return itens
        .map((item) => this.textoItemAppLicenca(item))
        .filter(Boolean)
        .map((texto) => this.escapeHtmlLicenca(texto))
        .join("<br>");
    },
    textoItemAppLicenca(item) {
      const nome =
        item.nome ||
        item.name ||
        item.titulo ||
        item.title ||
        item.codigo ||
        item.code ||
        "App";
      const valorAnual = this.primeiroValorNumericoLicenca(
        item.valor_anual,
        item.anual_total,
        item.total_anual,
        item.annual_price
      );
      const valorMensal = this.primeiroValorNumericoLicenca(
        item.valor_mensal,
        item.mensal_total,
        item.total_mensal,
        item.monthly_price
      );
      const valores = [];

      if (valorAnual > 0) {
        valores.push(`${this.formatarMoedaLicenca(valorAnual)}/ano`);
      }

      if (valorMensal > 0) {
        valores.push(`${this.formatarMoedaLicenca(valorMensal)}/mês`);
      }

      return valores.length ? `${nome} - ${valores.join(" + ")}` : nome;
    },
    escapeHtmlLicenca(texto) {
      return String(texto)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    textoValidadeFeature(feature) {
      if (feature.renewal_behavior === "keep_free") {
        return "Sem data de expiração";
      }

      if (!feature.valid_until) {
        return "Válido até o vencimento do plano";
      }

      return `Válido até: ${this.formatarDataFeature(feature.valid_until)}`;
    },
    formatarDataFeature(dataStr) {
      if (!dataStr) return "";
      const somenteData = String(dataStr).split("T")[0];
      const partes = somenteData.split("-");

      if (partes.length === 3) {
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
      }

      return new Date(dataStr).toLocaleDateString("pt-BR");
    },
    async salvarFeatures() {
      if (!this.empresaFeaturesSelecionada) return;

      this.salvandoFeatures = true;

      try {
        const features = this.featuresEmpresa
          .filter((feature) => feature.code && !this.isComingSoon(feature))
          .map((feature) => {
            const active = Boolean(feature.active);
            const minQuantity = Math.max(1, Number(feature.min_quantity || 1));
            const quantity =
              active && feature.billing_mode === "per_quantity"
                ? Math.max(minQuantity, Number(feature.quantity || minQuantity))
                : 1;
            const item = {
              code: feature.code,
              active,
              quantity,
            };

            if (active) {
              item.source = "manual";
              item.renewal_behavior =
                feature.renewal_behavior || "charge_on_renewal";
            }

            return item;
          });

        await this.$http.put(
          `/admin/empresas/${this.empresaFeaturesSelecionada.id_empresa}/features`,
          {
            features,
          }
        );

        this.$toast.success("Módulos e plugins atualizados com sucesso!");
        this.$bvModal.hide("modal-features-empresa");
      } catch (e) {
        this.$toast.error("Erro ao salvar módulos e plugins.");
      } finally {
        this.salvandoFeatures = false;
      }
    },
    async gerarRelatorioMensal() {
      this.addLoadingToButton("clientesMensal");
      try {
        await this.$http
          .post("/empresa/clientes-mensal")
          .then((result) => {
            if (result["data"]["url_pdf"]) {
              window.open(result["data"]["url_pdf"], "_blank");
            }
            this.$toast.success("Relatório gerado com sucesso!");
            this.$bvModal.hide("menuAcoes");
            this.$bvModal.hide("clientesMensal");
          })
          .catch(() => {});
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("clientesMensal");
      } catch (error) {
        this.$bvModal.hide("clientesMensal");
      }
      this.removeLoadingToButton("clientesNuts");
    },
    async gerarFaturamentoSegmentado() {
      if (!this.formFaturamento.data_inicio || !this.formFaturamento.data_fim) {
        this.$toast.warning("Informe as datas de início e fim!");
        return;
      }

      this.addLoadingToButton("faturamentoSegmentado");
      try {
        const result = await this.$http.post(
          "/empresa/faturamento-segmentado",
          {
            data_inicio: this.formFaturamento.data_inicio,
            data_fim: this.formFaturamento.data_fim,
          }
        );

        if (result?.data?.url_pdf) {
          window.open(result.data.url_pdf, "_blank");
          this.$toast.success("Relatório gerado com sucesso!");
        } else {
          this.$toast.success("Relatório processado com sucesso!");
        }

        this.$bvModal.hide("faturamentoSegmentado");

        // Limpa os campos
        this.formFaturamento.data_inicio = null;
        this.formFaturamento.data_fim = null;
      } catch (error) {
        this.$toast.error("Erro ao gerar relatório de faturamento.");
      } finally {
        this.removeLoadingToButton("faturamentoSegmentado");
      }
    },
    async gerarRelatorioNuts() {
      this.addLoadingToButton("clientesNuts");
      try {
        await this.$http
          .post("/empresa/clientes-nuts")
          .then((result) => {
            if (result["data"]["url_pdf"]) {
              window.open(result["data"]["url_pdf"], "_blank");
            }
            this.$toast.success("Relatório gerado com sucesso!");
            this.$bvModal.hide("menuAcoes");
            this.$bvModal.hide("clientesNuts");
          })
          .catch(() => {});
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("clientesNuts");
      } catch (error) {
        this.$bvModal.hide("clientesNuts");
      }
      this.removeLoadingToButton("clientesNuts");
    },
    async gerarRelatorioPorUF() {
      this.addLoadingToButton("clientePorUF");
      try {
        await this.$http
          .post("/empresa/clientes-by-uf")
          .then((result) => {
            if (result["data"]["url_pdf"]) {
              window.open(result["data"]["url_pdf"], "_blank");
            }
            this.$toast.success("Relatório gerado com sucesso!");
            this.$bvModal.hide("menuAcoes");
            this.$bvModal.hide("clientePorUF");
          })
          .catch(() => {});
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("clientePorUF");
      } catch (error) {
        this.$bvModal.hide("clientePorUF");
      }
      this.removeLoadingToButton("clientesRevendas");
    },
    async gerarRelatorioRevendasNuts() {
      this.addLoadingToButton("clientesRevendas");
      try {
        await this.$http
          .post("/empresa/clientes-revendas-nuts")
          .then((result) => {
            if (result["data"]["url_pdf"]) {
              window.open(result["data"]["url_pdf"], "_blank");
            }
            this.$toast.success("Relatório gerado com sucesso!");
            this.$bvModal.hide("menuAcoes");
            this.$bvModal.hide("clientesRevendas");
          })
          .catch(() => {});
        this.$bvModal.hide("menuAcoes");
        this.$bvModal.hide("clientesRevendas");
      } catch (error) {
        this.$bvModal.hide("clientesRevendas");
      }
      this.removeLoadingToButton("clientesRevendas");
    },
    async verUsoEmpresa(data) {
      this.empresaUsoSelecionada = data;
      this.usoEmpresa = null;
      this.loadingUso = true;
      this.$bvModal.show("modal-uso-empresa");
      try {
        const result = await this.$http.post("/empresa/uso-empresa", {
          id_empresa: data.id_empresa,
        });
        this.usoEmpresa = result.data.data ?? result.data;
      } catch (e) {
        this.$toast.error("Erro ao carregar dados de uso.");
        this.$bvModal.hide("modal-uso-empresa");
      } finally {
        this.loadingUso = false;
      }
    },
    diasDesde(dataStr) {
      if (!dataStr) return null;
      const agora = new Date();
      const data = new Date(dataStr);
      const hoje = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        agora.getDate()
      );
      const dataLocal = new Date(
        data.getFullYear(),
        data.getMonth(),
        data.getDate()
      );
      const dias = Math.floor((hoje - dataLocal) / (1000 * 60 * 60 * 24));
      if (dias === 0) return "Hoje";
      if (dias === 1) return "Ontem";
      return `${dias} dias atrás`;
    },
    formatUsoDt(dataStr) {
      if (!dataStr) return "";
      return new Date(dataStr).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    tornarRevenda(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Deseja tornar Revenda o  cliente: " + data.nome + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/empresa/tornar-revenda", {
              id_empresa: data.id_empresa,
            });
            this.$refs.clientes.refresh();
            this.$toast.success("Cliente Atualizado!");
          }
        });
    },
    bloquearAcesso(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Deseja bloquear acesso ao cliente " + data.nome + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/empresa/bloquear-cliente", {
              id_empresa: data.id_empresa,
            });
            this.$refs.clientes.refresh();
            this.$toast.success("Acesso bloqueado!");
          }
        });
    },
    liberarAcesso(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Deseja liberar acesso ao cliente " + data.nome + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/empresa/liberar-cliente", {
              id_empresa: data.id_empresa,
            });
            this.$refs.clientes.refresh();
            this.$toast.success("Acesso liberado!");
          }
        });
    },
    setarLicencas(data) {
      this.$swal
        .fire({
          title: "Deseja setar licenças para essa revenda?",
          text: "Informe o número de licenças desejada!",
          icon: "info",
          html: `
      <input type="text" id="total" class="swal2-input" placeholder="Número">`,
          confirmButtonText: "Enviar",
          cancelButtonText: "Cancelar",
          focusConfirm: false,
          showCancelButton: true,
          preConfirm: async () => {
            const total = this.$swal.getPopup().querySelector("#total").value;

            if (!total) {
              this.$toast.warning("Informe o número de licenças");
            }
            await this.$http
              .post("/empresa/inserir-licenca", {
                total: total,
                id_empresa: data.id_empresa,
                revenda: false,
                id_revenda: null,
              })
              .then(() => {
                this.$toast.success("Licenças inseridas com sucesso!");
                this.$refs.clientes.refresh();
              })
              .catch(() => {});
          },
        })
        .then(() => {});
    },
    setarCreditosUnicheck(data) {
      this.$swal
        .fire({
          title: "Deseja setar créditos Unicheck para consulta de CPFs?",
          text: "Informe o número de créditos desejado!",
          icon: "info",
          html: `
      <input type="text" id="total" class="swal2-input" placeholder="Número">`,
          confirmButtonText: "Creditar",
          cancelButtonText: "Cancelar",
          focusConfirm: false,
          showCancelButton: true,
          preConfirm: async () => {
            const total = this.$swal.getPopup().querySelector("#total").value;

            if (!total) {
              this.$toast.warning("Informe o número de licenças");
            }

            await this.$http
              .post("/saldo/create", {
                saldo: total,
                id_empresa: data.id_empresa,
                tipo: 1,
              })
              .then(() => {
                this.$toast.success("Créditos inseridos com sucesso!");
                this.$refs.clientes.refresh();
              })
              .catch(() => {});
          },
        })
        .then(() => {});
    },
    setarNivel(data) {
      this.$swal
        .fire({
          title:
            "Deseja setar nível partner do parceiro? 1-Start, 2-Prime, 3-Pró, 4-Elite, 5-Supreme!",
          icon: "info",
          html: `
      <input type="text" id="nivel" class="swal2-input" placeholder="Nível">`,
          confirmButtonText: "Atribuir",
          cancelButtonText: "Cancelar",
          focusConfirm: false,
          showCancelButton: true,
          preConfirm: async () => {
            const nivel = this.$swal.getPopup().querySelector("#nivel").value;

            if (!nivel) {
              this.$toast.warning("Informe o nível do parceiro");
            }

            await this.$http
              .post("/empresa/create-nivel-parceiro", {
                nivel: nivel,
                id_revenda: data.id_empresa,
              })
              .then(() => {
                this.$toast.success("Nível Partner definido ao parceiro!");
                this.$refs.clientes.refresh();
              })
              .catch(() => {});
          },
        })
        .then(() => {});
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "isNuts"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    moduleName() {
      return this.$route.fullPath.replace("/", "");
    },
    config() {
      return this.layoutConfig();
    },
    appsClienteSelecionado() {
      if (!this.clienteAppsSelecionado) return [];
      return this.resumoLicenca(this.clienteAppsSelecionado).apps.itens;
    },
    documentoRevendaSaldoSelecionada() {
      const documento = this.revendaSaldoSelecionada?.cnpj_cpf;

      if (!documento) return "Não informado";

      try {
        return this.formatCpfCnpj(documento);
      } catch (e) {
        return documento;
      }
    },
    documentoEmpresaSelecionada() {
      const documento = this.empresaFeaturesSelecionada?.cnpj_cpf;

      if (!documento) return "Não informado";

      try {
        return this.formatCpfCnpj(documento);
      } catch (e) {
        return documento;
      }
    },
    planoAtualEmpresaSelecionada() {
      if (!this.empresaFeaturesSelecionada) return "Não informado";

      const textoPlano =
        this.empresaFeaturesSelecionada.plano ||
        this.empresaFeaturesSelecionada.plan_name ||
        this.empresaFeaturesSelecionada.nome_plano;

      if (textoPlano) return textoPlano;

      return this.obterPlanoPorId(this.empresaFeaturesSelecionada.id_plan);
    },
    featuresFiltradas() {
      const termoBusca = this.buscaFeatures
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

      return this.featuresEmpresa.filter((feature) => {
        if (this.filtroRapidoFeatures === "module" && feature.type !== "module") {
          return false;
        }
        if (this.filtroRapidoFeatures === "plugin" && feature.type !== "plugin") {
          return false;
        }
        if (this.filtroRapidoFeatures === "active" && !feature.active) {
          return false;
        }
        if (this.filtroRapidoFeatures === "inactive" && feature.active) {
          return false;
        }
        if (
          this.filtroRapidoFeatures === "coming_soon" &&
          !this.isComingSoon(feature)
        ) {
          return false;
        }
        if (
          this.filtroRapidoFeatures === "per_quantity" &&
          feature.billing_mode !== "per_quantity"
        ) {
          return false;
        }

        if (!termoBusca) return true;

        const conteudoBusca = [
          feature.name,
          feature.description,
          feature.code,
          feature.status,
          feature.available === false ? "em breve" : "",
          ...(feature.tags || []),
          ...(feature.recommended_for || []),
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

        return conteudoBusca.includes(termoBusca);
      });
    },
    featuresAgrupadas() {
      return {
        modules: this.featuresFiltradas.filter((feature) => feature.type === "module"),
        plugins: this.featuresFiltradas.filter((feature) => feature.type === "plugin"),
      };
    },
    resumoAppsAtivos() {
      return this.featuresEmpresa.filter(
        (feature) => feature.active && !this.isComingSoon(feature)
      ).length;
    },
    totalReferencia() {
      return this.featuresEmpresa.reduce((acc, feature) => {
        if (!feature.active || this.isComingSoon(feature)) return acc;

        const valorUnitario = Number(feature.monthly_price || 0);
        const quantidade =
          feature.billing_mode === "per_quantity"
            ? Math.max(1, Number(feature.quantity || feature.min_quantity || 1))
            : 1;

        return acc + valorUnitario * quantidade;
      }, 0);
    },
    totalReferenciaFormatado() {
      return `${this.numberToReal(this.totalReferencia, 2)}/mês`;
    },
    temperaturaUso() {
      if (!this.usoEmpresa) return { tipo: "frio", dias: null };
      const timestamps = [
        this.usoEmpresa.ultimo_login,
        this.usoEmpresa.ultima_nfe,
        this.usoEmpresa.ultima_atualizacao_pessoa,
        this.usoEmpresa.ultima_atualizacao_produto,
        this.usoEmpresa.ultimo_pedido,
        this.usoEmpresa.ultimo_orcamento,
        this.usoEmpresa.ultima_ordem_servico,
      ]
        .filter(Boolean)
        .map((d) => new Date(d).getTime());
      if (!timestamps.length) return { tipo: "frio", dias: null };
      const maisRecente = Math.max(...timestamps);
      const dias = Math.floor(
        (Date.now() - maisRecente) / (1000 * 60 * 60 * 24)
      );
      if (dias <= 7) return { tipo: "quente", dias };
      if (dias <= 30) return { tipo: "morno", dias };
      return { tipo: "frio", dias };
    },
    temperaturaScore() {
      if (!this.temperaturaUso || this.temperaturaUso.dias === null) return 0;
      return Math.max(
        0,
        Math.round(100 - (this.temperaturaUso.dias / 90) * 100)
      );
    },
    metricasUso() {
      if (!this.usoEmpresa) return [];
      const calcDias = (d) =>
        d
          ? Math.floor(
              (Date.now() - new Date(d).getTime()) / (1000 * 60 * 60 * 24)
            )
          : null;
      return [
        {
          label: "Último Login",
          icone: "👤",
          valor: this.usoEmpresa.ultimo_login,
          dias: calcDias(this.usoEmpresa.ultimo_login),
        },
        {
          label: "Última NF-e Emitida",
          icone: "📄",
          valor: this.usoEmpresa.ultima_nfe,
          dias: calcDias(this.usoEmpresa.ultima_nfe),
        },
        {
          label: "Últ. Atualiz. de Pessoa",
          icone: "👥",
          valor: this.usoEmpresa.ultima_atualizacao_pessoa,
          dias: calcDias(this.usoEmpresa.ultima_atualizacao_pessoa),
        },
        {
          label: "Últ. Atualiz. de Produto",
          icone: "📦",
          valor: this.usoEmpresa.ultima_atualizacao_produto,
          dias: calcDias(this.usoEmpresa.ultima_atualizacao_produto),
        },
        {
          label: "Último Pedido",
          icone: "🛒",
          valor: this.usoEmpresa.ultimo_pedido,
          dias: calcDias(this.usoEmpresa.ultimo_pedido),
        },
        {
          label: "Último Orçamento",
          icone: "📋",
          valor: this.usoEmpresa.ultimo_orcamento,
          dias: calcDias(this.usoEmpresa.ultimo_orcamento),
        },
        {
          label: "Última Ordem de Serviço",
          icone: "🔧",
          valor: this.usoEmpresa.ultima_ordem_servico,
          dias: calcDias(this.usoEmpresa.ultima_ordem_servico),
        },
      ];
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    if (!this.isNuts) {
      this.$router.push({ name: "dashboard" });
    }
  },
  watch: {
    "formPlano.id_plan"(novoPlano) {
      if (Number(novoPlano) === 1) {
        const hoje = new Date();
        hoje.setFullYear(hoje.getFullYear() + 1);

        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, "0");
        const dia = String(hoje.getDate()).padStart(2, "0");

        this.formPlano.data_validade = `${ano}-${mes}-${dia}`;
      }
    },
  },
};
</script>

<style scoped>
.revenda-admin-header {
  margin: 12px 0 14px;
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(520px, 2fr);
  gap: 12px;
}

.reseller-card,
.metric-card-item {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
}

.reseller-card {
  padding: 14px;
}

.reseller-kicker {
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-size: 11px;
  color: #7e8299;
  font-weight: 700;
}

.reseller-title {
  margin: 6px 0 10px;
  font-size: 20px;
  color: #181c32;
}

.reseller-line {
  display: flex;
  gap: 6px;
  color: #5e6278;
  font-size: 12px;
  margin-bottom: 4px;
}

.reseller-metrics-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.metric-card-item {
  padding: 10px 12px;
}

.metric-card-item span {
  display: block;
  color: #7e8299;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
}

.metric-card-item strong {
  color: #181c32;
  font-size: 17px;
  line-height: 1.3;
}

.admin-quick-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.quick-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(560px, 100%);
}

.quick-chips-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.quick-filter-chip {
  border: 1px solid #d8dbe7;
  border-radius: 14px;
  background: #fff;
  color: #5e6278;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 8px 11px;
}

.quick-filter-chip.ativo {
  border-color: #0d6efd;
  color: #0d6efd;
  background: #ecf4ff;
}

.cliente-cell,
.documento-cell,
.apps-cell,
.reseller-info-cell,
.status-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.cliente-main {
  color: #181c32;
  font-size: 14px;
  font-weight: 700;
}

.cliente-muted {
  color: #7e8299;
  font-size: 12px;
  line-height: 1.2;
}

.cliente-chip-wrap {
  margin-top: 3px;
}

.apps-active-count {
  color: #181c32;
  font-weight: 700;
  font-size: 12px;
}

.apps-active-names {
  color: #5e6278;
  font-size: 12px;
  line-height: 1.25;
}

.reseller-info-cell {
  min-width: 130px;
  color: #3f4254;
}

.reseller-info-line {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 3px 0;
}

.reseller-info-line span {
  color: #7e8299;
  font-size: 11px;
  line-height: 1.1;
  font-weight: 700;
}

.reseller-info-line strong {
  color: #181c32;
  font-size: 12px;
  line-height: 1.2;
}

.license-summary-cell {
  min-width: 190px;
  max-width: 250px;
  color: #3f4254;
  font-size: 12px;
  line-height: 1.35;
}

.licenca-cell {
  min-width: 240px;
}

.license-plan-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
  color: #181c32;
}

.license-plan-line strong {
  font-size: 12px;
  line-height: 1.2;
}

.license-plan-badge {
  min-width: 26px;
  height: 20px;
  padding: 0 6px;
  border-radius: 4px;
  background: #e8fff3;
  color: #1bc5bd;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.license-muted {
  color: #7e8299;
}

.license-lines {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eef0f6;
}

.license-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 3px;
}

.license-row span:first-child {
  flex-shrink: 0;
}

.license-row strong,
.license-row span:last-child {
  text-align: right;
}

.license-apps-row {
  cursor: help;
}

.license-empty {
  color: #7e8299;
  font-weight: 600;
  margin-top: 4px;
}

.license-total-line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eef0f6;
  color: #181c32;
}

.license-total-line strong {
  font-size: 13px;
}

.license-recurring-line {
  margin-top: 2px;
  color: #8950fc;
  font-weight: 700;
  text-align: right;
}

.license-status-line {
  margin-top: 6px;
}

.row-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  white-space: nowrap;
}

.row-actions-toggle {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  padding: 6px 10px;
}

.action-item-icon {
  flex: 0 0 auto;
  margin-right: 9px;
  color: #5e6278;
}

.company-users-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.company-user-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
}

.company-user-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.company-user-info .text-muted {
  overflow-wrap: anywhere;
}

.empty-users-state {
  padding: 28px 16px;
  text-align: center;
  color: #7e8299;
  font-weight: 600;
}

.empty-apps-state {
  text-align: center;
  padding: 16px;
  color: #7e8299;
  font-weight: 600;
}

.apps-detail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.apps-detail-item {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.apps-detail-meta {
  color: #7e8299;
  font-size: 12px;
}

.apps-detail-price {
  color: #181c32;
  font-weight: 700;
  text-align: right;
}

.saldo-apps-modal {
  display: flex;
  flex-direction: column;
}

.saldo-apps-header {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fcfcfd;
  padding: 12px;
  display: grid;
  gap: 6px;
}

.saldo-apps-label {
  color: #7e8299;
  font-size: 12px;
  margin-right: 6px;
}

.saldo-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.saldo-card-item {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}

.saldo-card-item span {
  color: #7e8299;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
}

.saldo-card-item strong {
  display: block;
  margin-top: 4px;
  color: #181c32;
  font-size: 20px;
}

.saldo-credit-form {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #fcfcfd;
  padding: 12px;
}

.saldo-extrato-table-wrap {
  max-height: 320px;
  overflow-y: auto;
}

.saldo-extrato-table {
  margin-bottom: 0;
}

.saldo-extrato-table th {
  font-size: 11px;
  text-transform: uppercase;
  color: #7e8299;
  white-space: nowrap;
}

.saldo-extrato-table td {
  font-size: 12px;
  color: #3f4254;
  vertical-align: middle;
}

.saldo-mov-valor {
  font-weight: 700;
}

.saldo-mov-credito {
  color: #1f8b4c;
}

.saldo-mov-debito {
  color: #d63343;
}

.feature-admin-modal {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.feature-admin-header {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  padding: 12px;
  background: #fcfcfd;
}

.feature-admin-search {
  max-width: 520px;
}

.feature-admin-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feature-filter-chip {
  border: 1px solid #d8dbe7;
  background: #fff;
  border-radius: 16px;
  font-size: 12px;
  line-height: 1;
  padding: 8px 12px;
  color: #5e6278;
  transition: all 0.2s ease;
}

.feature-filter-chip.ativo {
  border-color: #0d6efd;
  color: #0d6efd;
  background: #ecf4ff;
  font-weight: 600;
}

.feature-admin-content {
  max-height: 56vh;
  overflow-y: auto;
  padding-right: 4px;
}

.feature-admin-group-title {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.8px;
  color: #7e8299;
  margin-bottom: 10px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.feature-admin-item {
  background: #fff;
  border-color: #e4e6ef !important;
  padding: 12px;
}

.feature-admin-item.ativo {
  border-color: #78b4ff !important;
  box-shadow: 0 2px 10px rgba(13, 110, 253, 0.08);
}

.feature-admin-item.em-breve {
  border-style: dashed !important;
  border-color: #f5b255 !important;
  background: #fffaf1;
}

.em-breve-badge {
  background: #fff4de;
  color: #b86a00;
  border: 1px solid #ffd9a0;
}

.feature-admin-main {
  min-width: 0;
  flex: 1;
}

.feature-admin-body {
  min-width: 0;
  width: 100%;
}

.feature-description {
  min-height: 38px;
}

.feature-admin-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  line-height: 1.5;
}

.feature-source-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 600;
}

.feature-source-badge.badge-manual {
  background: #ecf4ff;
  color: #0d6efd;
}

.feature-source-badge.badge-marketplace {
  background: #e9f8ef;
  color: #1f8b4c;
}

.feature-source-badge.badge-legacy {
  background: #f3f3f5;
  color: #4f4f62;
}

.feature-source-badge.badge-renewal {
  background: #fff7e8;
  color: #9a6b00;
}

.feature-source-badge.badge-revenda {
  background: #f0ecff;
  color: #5f3dc4;
}

.feature-quantity {
  border: 1px solid #eceef3;
  border-radius: 8px;
  padding: 10px;
  background: #fcfdff;
}

.feature-quantity-label {
  display: block;
  font-size: 12px;
  color: #7e8299;
  margin-bottom: 6px;
}

.feature-quantity-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.feature-quantity-value {
  min-width: 30px;
  text-align: center;
  font-weight: 700;
  color: #181c32;
}

.feature-admin-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
  border-top: 1px solid #e4e6ef;
  margin: 10px -16px -16px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.feature-admin-actions {
  display: flex;
  align-items: center;
}

@media (max-width: 991px) {
  .revenda-admin-header {
    grid-template-columns: 1fr;
  }

  .reseller-metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .quick-search-wrap {
    width: 100%;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }

  .feature-admin-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .feature-admin-actions {
    justify-content: flex-end;
  }
}

@media (max-width: 640px) {
  .reseller-metrics-grid {
    grid-template-columns: 1fr;
  }

  .saldo-cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
.revenda-actions-popover {
  min-width: 245px;
  max-width: 280px;
}

.revenda-actions-popover .popover-body {
  padding: 0.35rem 0;
}

.revenda-actions-menu {
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}

.revenda-actions-popover .dropdown-item {
  align-items: center;
  display: flex;
  min-height: 36px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
